import ContactsWidgetChart from 'react/components/dashboard/contacts_widget_chart';

angular.module('gym.components').value('ContactsWidgetChart', ContactsWidgetChart);
